import React, { Component } from "react";
import styled, { css } from "styled-components";
import { observer } from "mobx-react";
import Icon from "module-common/Icon";
import { NotificationStore } from "Store";

const Themes = {
  error: {
    icon: "alert-error",
    color: "alertError"
  },
  warn: {
    icon: "alert-warning",
    color: "alertWarning"
  },
  info: {
    icon: "alert-info",
    color: "alertInfo"
  },
  success: {
    icon: "alert-success",
    color: "alertSuccess"
  }
};

export default observer(
  class AlertWrapper extends Component {
    cancelWipeBox() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    wipeBoxOnFuture() {
      this.timer = setTimeout(() => {
        NotificationStore.currentState = { type: null };
      }, 3000);
    }

    render() {
      let { currentState } = NotificationStore;
      this.cancelWipeBox();
      this.wipeBoxOnFuture();

      return (
        <Wrapper isShown={currentState.type} type={currentState.type}>
          <Icon
            width={31}
            height={31}
            name={currentState.type ? Themes[currentState.type].icon : null}
          />
          <AlertLabel>{currentState.message}</AlertLabel>
          <Icon
            width={15}
            height={15}
            name="x-button"
            onClick={() => {
              this.cancelWipeBox();
              NotificationStore.currentState = { type: null };
            }}
          />
        </Wrapper>
      );
    }
  }
);

const Wrapper = styled.div`
  position: absolute;
  width: 500px;
  height: 60px;
  top: 0;
  left: 50%;
  margin-left: -250px;
  align-items: center;
  border-radius: 5px;
  padding: 10px 20px;
  z-index: 999;
  ${props =>
    props.type &&
    css`
      background-color: ${props.theme[Themes[props.type].color]};
    `};
  ${props =>
    props.isShown
      ? css`
          display: flex;
        `
      : css`
          display: none;
        `};
`;
const AlertLabel = styled.div`
  color: white;
  font-size: 1.1rem;
  padding: 0 20px;
  margin-right: auto;
`;



// WEBPACK FOOTER //
// ./src/module-common/NotificationBox.js